import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import FrontHistory from "../components/tugFront/history/FrontHistory";
import FrontSummaryV2 from "../components/tugFront/v2/FrontSummaryV2";
import SideHistory from "../components/tugSide/history/SideHistory";
import SideSummaryV2 from "../components/tugSide/v2/SideSummaryV2";
import MetricTrendView from "../components/tugSide/trend/MetricTrendView";
import FrontTugPdfReport from "../components/tugFront/pdf/FrontTugPdfReport";
import SideTugPdfReport from "../components/tugSide/pdf/SideTugPdfReport";
import {
  FRONT_TUG_HISTORY,
  FRONT_TUG_METRIC_TREND,
  FRONT_TUG_SUMMARY_V1,
  FRONT_TUG_SUMMARY_V2,
  SIDE_TUG_HISTORY,
  SIDE_TUG_METRIC_TREND,
  SIDE_TUG_SUMMARY_V2,
  FRONT_TUG_V2_PDF,
  SIDE_TUG_V2_PDF,
} from "./routerPath";

const router = createBrowserRouter([
  {
    path: "",
    element: <App />,
    children: [
      {
        path: FRONT_TUG_SUMMARY_V1,
        element: <FrontSummaryV2 />,
      },
      {
        path: FRONT_TUG_SUMMARY_V2,
        element: <FrontSummaryV2 />,
      },
      {
        path: FRONT_TUG_HISTORY,
        element: <FrontHistory />,
      },
      {
        path: FRONT_TUG_METRIC_TREND,
        element: <MetricTrendView />,
      },
      {
        path: SIDE_TUG_SUMMARY_V2,
        element: <SideSummaryV2 />,
      },
      {
        path: SIDE_TUG_HISTORY,
        element: <SideHistory />,
      },
      {
        path: SIDE_TUG_METRIC_TREND,
        element: <MetricTrendView />,
      },
      {
        path: FRONT_TUG_V2_PDF,
        element: <FrontTugPdfReport />,
      },
      {
        path: SIDE_TUG_V2_PDF,
        element: <SideTugPdfReport />,
      },
    ],
  },
]);

export default router;
